import React, { useEffect, useState, useRef } from 'react';
import { JSResourceForBackground } from '@atlassian/react-async';

type ForgeUiGlobalExtension = typeof import('./index').default;

const forgeUiGlobalResource = JSResourceForBackground<ForgeUiGlobalExtension>(() =>
	import(/* webpackChunkName: "forge-ui-global-resources" */ './index').then((m) => m.default),
);

export const ForgeUiGlobalExtensionsAsync: React.FC = () => {
	const [LoadedComponent, setLoadedComponent] = useState<ForgeUiGlobalExtension | null>(null);
	const mounted = useRef(false);

	useEffect(() => {
		mounted.current = true;

		if (!LoadedComponent) {
			forgeUiGlobalResource.load().then((resource) => {
				if (!mounted.current) return;
				const Comp = resource;
				if (Comp) {
					setLoadedComponent(() => Comp);
				}
			});
		}

		return () => {
			mounted.current = false;
		};
	}, [LoadedComponent]);

	return LoadedComponent && <LoadedComponent />;
};
